export type SpaceTokenValue = number;

export enum SpaceTokenName {
  X0 = 'x0',
  X1 = 'x1',
  X2 = 'x2',
  X3 = 'x3',
  X4 = 'x4',
  X5 = 'x5',
  X6 = 'x6',
  X8 = 'x8',
  X10 = 'x10',
  X12 = 'x12',
  X16 = 'x16',
  X20 = 'x20',
}

export type SpaceJoinArgs = Array<SpaceTokenName | `${SpaceTokenName}`>;

export type SpaceTokenRecord = {
  join: (...args: SpaceJoinArgs) => string;
} & Record<SpaceTokenName, SpaceTokenValue>;

export const spaces: SpaceTokenRecord = {
  [SpaceTokenName.X0]: 0,
  [SpaceTokenName.X1]: 2,
  [SpaceTokenName.X2]: 4,
  [SpaceTokenName.X3]: 6,
  [SpaceTokenName.X4]: 8,
  [SpaceTokenName.X5]: 10,
  [SpaceTokenName.X6]: 12,
  [SpaceTokenName.X8]: 16,
  [SpaceTokenName.X10]: 20,
  [SpaceTokenName.X12]: 24,
  [SpaceTokenName.X16]: 32,
  [SpaceTokenName.X20]: 40,

  join: (...args) => args.map(key => `${spaces[key]}px`).join(' '),
};
